import { configureStore } from "@reduxjs/toolkit";
import { requestUserDataReducer } from "../reducers/RequestUserDataReducer";
import { requestLogOutReducer } from "../reducers/RequestLogOutReducer";
import { modelReducer } from "../reducers/ModelReducer";
import { globalReducer } from "../reducers/GlobalReducer";
import { navigationReducer } from "../reducers/NavigationReducer";
import { markupReducer } from "../reducers/MarkupReducer";

// const store = createStore(
//   rootReducers,
//   composeWithDevTools(applyMiddleware(thunk))
// );

const store = configureStore({
  reducer: {
    userData: requestUserDataReducer,
    logOut: requestLogOutReducer,
    modelReducer,
    globalReducer,
    navigationReducer,
    markupReducer,
  },
});

export default store;
